import script from "./PageTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PageTable.vue?vue&type=script&setup=true&lang=js"

import "./PageTable.vue?vue&type=style&index=0&id=74532e04&lang=scss&scoped=true"

import exportComponent from "/Users/apple/Documents/yang/yiwu-commodity-wms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74532e04"]])

export default __exports__